import { Download, Printer } from 'lucide-react';
import { Button } from './ui/Button';
import { useToast } from './ui/Toast';
import { downloadCsv, printReportAsPdf } from '../lib/reportExport';

export interface ReportColumn<T> {
  header: string;
  value: (row: T) => string | number;
}

// Drop-in "Export CSV" / "Export PDF" pair for any tabular report - columns
// describe how to flatten a row of T into cells, shared by both formats so
// the two exports never drift out of sync with each other.
export function ReportExportBar<T>({
  filename,
  title,
  subtitle,
  columns,
  rows,
}: {
  filename: string;
  title: string;
  subtitle?: string;
  columns: ReportColumn<T>[];
  rows: T[];
}) {
  const { showToast } = useToast();
  const headers = columns.map((c) => c.header);
  const tableRows = rows.map((row) => columns.map((c) => c.value(row)));

  function handlePdf() {
    try {
      printReportAsPdf(title, headers, tableRows, subtitle);
    } catch (err) {
      showToast(err instanceof Error ? err.message : 'Could not open the print window.', 'error');
    }
  }

  return (
    <div className="flex items-center gap-1.5">
      <Button size="sm" variant="ghost" disabled={rows.length === 0} onClick={() => downloadCsv(filename, headers, tableRows)}>
        <Download className="h-3.5 w-3.5" /> CSV
      </Button>
      <Button size="sm" variant="ghost" disabled={rows.length === 0} onClick={handlePdf}>
        <Printer className="h-3.5 w-3.5" /> PDF
      </Button>
    </div>
  );
}
